import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle, EnvelopeSimple, PhoneCall, Sun } from "@phosphor-icons/react";

export default function StepThankYou({ leadResult, analysis, residency = "owner" }) {
  const isRenter = residency === "renter";
  const tou = analysis?.tou_savings;
  return (
    <div data-testid="step-thankyou" className="max-w-3xl mx-auto text-center">
      <div className="w-20 h-20 mx-auto rounded-full bg-emerald-100 flex items-center justify-center mb-8">
        <CheckCircle size={48} weight="fill" className="text-emerald-500" />
      </div>
      <h2 className="font-display text-4xl sm:text-5xl font-bold text-slate-950 tracking-tight">
        You're all set.
      </h2>
      <p className="mt-4 text-lg text-slate-600">
        {isRenter
          ? "Your TOU savings plan and HVAC partner contacts have been queued. A specialist will email or call within 24 hours."
          : "Your free analysis has been sent to a Maui Starpower specialist. Expect a call or email within"}
        {!isRenter && <span className="font-semibold text-slate-900"> 24 hours</span>}
        {!isRenter && "."}
      </p>

      {analysis && !isRenter && (
        <div className="card-clean p-8 mt-10 text-left">
          <h3 className="font-display text-lg font-semibold text-slate-900 mb-4">Quick recap</h3>
          <div className="grid sm:grid-cols-3 gap-5">
            <Stat label="System size" value={`${analysis.recommendation.system_kw} kW`} />
            <Stat label="25-yr savings" value={`$${(analysis.recommendation.twenty_five_year_savings / 1000).toFixed(0)}k`} />
            <Stat label="Payback" value={`${analysis.recommendation.payback_years} yrs`} />
          </div>
        </div>
      )}

      {analysis && isRenter && tou && (
        <div className="card-clean p-8 mt-10 text-left">
          <h3 className="font-display text-lg font-semibold text-slate-900 mb-4">Quick recap</h3>
          <div className="grid sm:grid-cols-3 gap-5">
            <Stat label="TOU savings" value={`$${tou.monthly_savings.toFixed(0)}/mo`} />
            <Stat label="Annual" value={`$${tou.annual_savings.toFixed(0)}`} />
            <Stat label="Peak share" value={`${tou.evening_share_pct}%`} />
          </div>
        </div>
      )}

      <div className="grid sm:grid-cols-3 gap-3 mt-8 text-left">
        <div className="card-clean p-5">
          <Sun size={22} weight="duotone" className="text-amber-500 mb-2" />
          <div className="font-semibold text-slate-900">Site visit</div>
          <div className="text-sm text-slate-500 mt-1">Free, no pressure</div>
        </div>
        <div className="card-clean p-5">
          <EnvelopeSimple size={22} weight="duotone" className="text-sky-500 mb-2" />
          <div className="font-semibold text-slate-900">Detailed quote</div>
          <div className="text-sm text-slate-500 mt-1">Tied to your bill</div>
        </div>
        <div className="card-clean p-5">
          <PhoneCall size={22} weight="duotone" className="text-emerald-500 mb-2" />
          <div className="font-semibold text-slate-900">Local team</div>
          <div className="text-sm text-slate-500 mt-1">Hawaii-based crews</div>
        </div>
      </div>

      <Link to="/" data-testid="thankyou-home-btn" className="btn-secondary inline-flex items-center mt-10">
        Back to home
      </Link>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="font-display text-2xl font-bold text-slate-950 mt-1">{value}</div>
    </div>
  );
}
